import { URL_SUPPORT } from '../../utils/constants/urls';
import LandscapeImage from './error-landscape.png';
import './styles.scss';
import type { FunctionComponent } from 'react';

type AllErrorMessageProps = {
  subjectAction: string;
  onButtonClick: () => void;
};

const AllErrorMessage: FunctionComponent<AllErrorMessageProps> = ({
  subjectAction = 'reactivate',
  onButtonClick = () => null,
}) => (
  <section className="error-page" data-testid="error-page-container">
    <div className="content" data-testid="error-page-content">
      <h2 className="content__title">An Error Occurred</h2>
      <p className="content__description" data-testid="error-page-description">
        We’re sorry, something went wrong. We were unable to {subjectAction} you! Please go back and
        try again. If the problem persists, contact FabFitFun Support{' '}
        <a href={URL_SUPPORT} target="_blank" rel="noreferrer">
          here
        </a>
        .
      </p>
      <button type="button" className="content__cta" onClick={onButtonClick}>
        TRY AGAIN
      </button>
      <img src={LandscapeImage} alt="landscape" className="content__image" />
    </div>
  </section>
);

export default AllErrorMessage;
